import { Dropdown, Menu } from "@mui/base";
import { columnFetcher, Listbox, MenuButton, MenuItem } from "../../Style";
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import "../../styles/App.scss";
import "../../styles/UserStyles.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FilterIcon from "@mui/icons-material/Tune";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UploadCSVDialog from "./UploadCSVDialog";
import InstantBookingButton from "../../Screens/Booking/InstantBookingButton";

const SearchAndButtonTab = ({
  searchQuery,
  searchColumn,
  columns,
  setSearchColumn,
  setSearchQuery,
  handleUploadCSV,
  handleExport,
  title,
  type,
  routeName,
  permissions,
  user,
}) => {
  const navigate = useNavigate();
  const isAdmin = user?.user_type === 1;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Track window width for responsive text
  console.log("searchQuery",searchQuery)
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleColumnChange = (event) => {
    setSearchColumn(event);
    setSearchQuery("");
  };

  const handleOpenDialog = () => setIsDialogOpen(true);
  const handleCloseDialog = () => setIsDialogOpen(false);

  const showAddButton = () => {
    if (title === "Bookings") {
      return (
        user?.role === "Customer" ||
        user?.role === "Vendor" ||
        permissions?.bookings?.add === true ||
        isAdmin
      );
    }
    if (title === "Customers") {
      return (
        user?.role === "Vendor" ||
        permissions?.customers?.add === true ||
        isAdmin
      );
    }
    if (isAdmin) {
      return true;
    }

    switch (title) {
      case "Services":
        return permissions?.services?.add === true;
      case "Airports":
        return permissions?.airports?.add === true;
      case "Staffs":
        return permissions?.staffs?.add === true;
      case "Vendors":
        return permissions?.vendors?.add === true;
      case "Customers":
        return permissions?.customers?.add === true;
      case "Roles":
        return permissions?.roles?.add === true;
      default:
        return false;
    }
  };

  
  const getUploadButtonText = () => {
    return windowWidth <= 425 ? "Upload" : "Upload CSV";
  };

  const getAddButtonText = () => {
    if (title === "Bookings") return "Book Now";
    return windowWidth <= 425 ? "Add" : `Add ${title.slice(0, -1)}`;
  };
  

  return (
    <>
      <Box className="action-container">
        <Box>
          <Typography variant="h5" className="form-heading">
            {title}
          </Typography>
        </Box>
        <Box className="view-navbar-tab">
          <Box className="search-container">
            <TextField
              variant="outlined"
              placeholder={` Search ${title}... `}
              size="small"
              className="search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            {/* <Dropdown>
              <MenuButton>
                <FilterIcon color="blue" />
                Filter
                <KeyboardArrowDownIcon className="caret" />
              </MenuButton>
              <Menu slots={{ listbox: Listbox }}>
                {columns.map((column) => (
                  <MenuItem
                    key={column.value}
                    onClick={() => handleColumnChange(column.value)}
                  >
                    {column.label}
                  </MenuItem>
                ))}
              </Menu>
            </Dropdown> */}
          </Box>
          <Box className="navbar-button-container">
            {!["Roles"].includes(title) ? (
              <Button
                variant="outlined"
                type="button"
                startIcon={<DownloadIcon />}
                size="small"
                className="export-button"
                onClick={handleExport}
              >
                Export
              </Button>
            ) : (
              <Button
                variant="outlined"
                type="button"
                startIcon={<DownloadIcon />}
                size="small"
                className="role-export-button"
                onClick={handleExport}
              >
                Export
              </Button>
            )}
            {!["Bookings", "Roles","Invoices"].includes(title) && (
              <Button
                variant="contained"
                component="label"
                size="small"
                className={"upload-button"}
                onClick={handleOpenDialog}
              >
                {getUploadButtonText()}
              </Button>
            )}

            {title === "Bookings" &&
              (user?.role === "Admin" || user?.role === "Staff") && (
                <InstantBookingButton user={user} />
              )}
            {showAddButton() && title !== "Payments" && (
              <Button
                variant="contained"
                size="small"
                className="add-button"
                onClick={() => {
                  navigate(routeName);
                }}
              >
                {getAddButtonText()}
              </Button>
            )}
         
          </Box>
        </Box>
      </Box>
      <UploadCSVDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        type={type}
      />
    </>
  );
};

export default SearchAndButtonTab;